import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useAdditionalOptions } from '~/modules/common/hooks';
import { useOptionsMerge } from '~/modules/common/components/SearchAutocomplete';
import { ClientDropdown } from '../../project/common/components';
import useClientDropdownOptionsForProject from './useClientDropdownOptionsForProject';
import useMyClientDropDownOptionsForProject from './useMyClientDropDownOptionsForProject';

export const ClientDropdownForProject = ({
  value,
  onChange,
  shouldFetchOnlyMyClients = false,
  enableNoChangeOption = false,
  enableNoValueOption = false,
  ...rest
}) => {
  const { formatMessage } = useIntl();
  const additionalOptions = useAdditionalOptions({
    enableNoChangeOption,
    enableNoValueOption,
    noValueMessageId: 'dropdownItem.noClient'
  });

  const { options, loading } = useClientDropdownOptionsForProject(
    shouldFetchOnlyMyClients
  );

  const {
    hasMore,
    options: myClientOptions,
    loading: myClientOptionsLoading
  } = useMyClientDropDownOptionsForProject(!shouldFetchOnlyMyClients);

  const mergedOptions = useOptionsMerge({
    options: shouldFetchOnlyMyClients ? myClientOptions : options,
    additionalOptions
  });

  return (
    <ClientDropdown
      hasMore={hasMore}
      options={mergedOptions}
      isLoading={shouldFetchOnlyMyClients ? myClientOptionsLoading : loading}
      value={value}
      onChange={onChange}
      optionTypeText={formatMessage({
        id: 'moreOptions.clients'
      })}
      {...rest}
    />
  );
};

ClientDropdownForProject.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  shouldFetchOnlyMyClients: PropTypes.bool,
  enableNoChangeOption: PropTypes.bool,
  enableNoValueOption: PropTypes.bool
};

export default ClientDropdownForProject;
